import { apiErrorHandler, oktaAxios as axios } from "@/vue/api/config";
import { defaultPagination } from "@/vue/utils/helper";
import { flatten } from "@/vue/utils/pbxes";
import defaultState from "@/vue/utils/defaultState";

const defState = defaultState("pbxes", {
  pbxes: [],
  pagination: defaultPagination(),
});

export const pbxes = {
  state: defState.state,
  getters: {
    getPbxes: (state) => state.pbxes,
    getPbx: (state) => (pbxId) =>
      state.pbxes.find((pbx) => pbx.pbxId === pbxId),
    getPagination: (state) => state.pagination,
  },
  mutations: {
    ...defState.mutations,
    SET_PBXES(state, { pbxes }) {
      state.pbxes = pbxes.map(flatten);
    },
    ADD_PBX(state, { pbx }) {
      state.pbxes.push(flatten(pbx));
    },
    REMOVE_PBX(state, { id }) {
      const index = state.pbxes.findIndex((tg) => tg.pbxId === id);
      state.pbxes.splice(index, 1);
    },
    SET_PBX_PAGINATION(state, { page, size }) {
      state.pagination = { page, size };
    },
  },
  actions: {
    async fetchPbxes({ commit, getters }, { customerId }) {
      let { page, size } = getters.getPagination;
      let pbxes = [];

      const fetch = async () => {
        const response = await axios
          .get(`/v1/customers/${customerId}/pbxes?page=${page}&size=${size}`)
          .catch(apiErrorHandler);
        if (response.data.length) {
          pbxes = pbxes.concat(response.data);
          page++;
          commit("SET_PBX_PAGINATION", { page, size });
          commit("SET_PBXES", { pbxes });
          fetch();
        }
      };

      await fetch();
    },
    async deletePbx({ commit }, { customerId, pbxId }) {
      await axios
        .delete(`/v1/customers/${customerId}/pbxes/${pbxId}`)
        .catch(apiErrorHandler);
      commit("REMOVE_PBX", { id: pbxId });
    },
    async bulkCreatePbxes({ commit, getters }, { customerId, pbxes }) {
      const response = await axios.post(
        `/v1/customers/${customerId}/pbxes/bulk`,
        pbxes
      );

      return response.data;
    },
    async fetchJobsByBatch({ commit, getters }, { batchId }) {
      const response = await axios
        .get(`/v1/jobs/batches/${batchId}`)
        .catch(apiErrorHandler);
      return response.data;
    },
    async fetchPbxNameWorkOrder(context, { pbxName }) {
      const response = await axios
        .get(`/v1/pbxes/name-check/${encodeURI(pbxName)}`)
        .catch(apiErrorHandler);
      return response.data;
    },
  },
};
